import React from 'react'

const PrivacySuspense = ({ isGlobalNav }) => (
  <div
    className={`privacy-${
      isGlobalNav ? 'globalnav' : 'commonutilsnav'
    }-suspense`}
  />
)

export default PrivacySuspense
